/** @format */

import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Margin } from "@mui/icons-material";

interface IOSSwitchProps {
   enable: boolean;
   handleSwitch: () => void;
}

const IOSSwitch = styled((props: SwitchProps) => (
   <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
   />
))(({ theme }) => ({
   width: 42,
   height: 26,
   padding: 0,
   "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
         transform: "translateX(16px)",
         color: "#fff",
         "& + .MuiSwitch-track": {
            backgroundColor: theme.palette.mode === "dark" ? "#0ED8E2" : "#0ED8E2",
            opacity: 1,
            border: 0,
         },
         "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
         },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
         color: "#33cf4d",
         border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
         color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
         opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
   },
   "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
   },
   "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
         duration: 500,
      }),
   },
}));

export default function CustomizedSwitches({ enable, handleSwitch }: IOSSwitchProps) {
   return (
      <FormGroup>
         <FormControlLabel
            sx={{ margin: "0px" }}
            control={
               <IOSSwitch
                  checked={enable}
                  onChange={handleSwitch}
               />
            }
            label=""
         />
      </FormGroup>
   );
}
